module.exports = __webpack_public_path__ + "assets/media/app-store.20223e10.svg";